import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './SupportPage.module.less';
import { MailOutlined, LaptopOutlined, QuestionCircleOutlined, FolderViewOutlined } from '@ant-design/icons';

export default function SupportPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.SupportPageContainer}>
				<h1 className={styles.SupportPageTitle}>Support</h1>
				<div className={styles.SupportPageDisplay}>
					<div className={styles.SupportPageSubdisplay1}>
						<div className={styles.SupportPageCard}>
							<div className={styles.SupportPageCardTop}>
								<div>
									<MailOutlined />
									&nbsp; Email Support
								</div>
								<a href="mailto:dev-support@virtuix.com">
									<div className={styles.SupportPageButton}>Email</div>
								</a>
							</div>
						</div>
						<div className={styles.SupportPageCard}>
							<div className={styles.SupportPageCardTop}>
								<div>
									<LaptopOutlined />
									&nbsp; Join the Discord Server
								</div>
								<a href="https://discord.gg/mdhyps4FUB" target="_blank" rel="noreferrer">
									<div className={styles.SupportPageButton}>Join</div>
								</a>
							</div>
						</div>
						<div className={styles.SupportPageCard70}>
							<div className={styles.SupportPageCardTop}>
								<div>
									<QuestionCircleOutlined />
									&nbsp; Frequently Asked Questions
								</div>
							</div>
							<div className={styles.SupportPageCardText}>
								<p>
									<b>What is our SDK for?</b>
									<br />
									A: Our SDK is intended for developers building applications to sell on the Omni One app store.
								</p>
								<p>
									<b>
										If I already developed a game for the Pico headset, do I have to start from scratch to make it work on Omni
										One?
									</b>
									<br />
									A: No, porting a game from Pico to Omni One is straightforward. Just verify that the Pico SDK plugin in your
									project is at or above version 2.1.2 and install our Omni One SDK. Then you'll just have to set the movement
									inputs to locomotion information coming from Omni One to make the player move properly in your game.
								</p>
								<p>
									<b>
										If I don’t have an Omni One system, can I simulate Omni One movement inputs in Unreal or Unity to test my
										game?
									</b>
									<br />
									A: An Omni emulation tool is on our roadmap but won’t be available right away. Our team will test your game
									with Omni One at our office to give you feedback.
								</p>
								<p>
									<b>How do I know if my game is selling and getting played?</b>
									<br />
									A: Your project interface on Omni Dev will give you full visibility of your game's analytics and financial
									performance. This includes the number of units sold, average play time, number of multiplayer sessions, and
									much more.
								</p>
								<p>
									<b>How can I try Omni One? </b>
									<br />
									A: You’re welcome any time to try Omni One at our headquarters in Austin, TX. Otherwise, get a taste of the
									Omni experience at one of over 70 entertainment venues in the U.S. that operate Omni Arena. See a list of
									locations{' '}
									<a href="https://arena.virtuix.com/locations" target="_blank" rel="noreferrer">
										here
									</a>
									.
								</p>
								<p>
									<b>What kind of support will the Virtuix team provide to me? </b>
									<br />
									A: Our developer relations team will provide you with full support within business hours to troubleshoot any
									issues you might have in your process of bringing great VR games to the Omni One store. Just let us know how
									we can help. We look forward to working with you!
								</p>
							</div>
						</div>
						<div className={styles.SupportPageCard30}>
							<div className={styles.SupportPageCardTop}>
								<div>
									<FolderViewOutlined />
									&nbsp; Troubleshooting
								</div>
							</div>
							<div className={styles.SupportPageCardText}>
								<p>
									If you experience issues when installing or using the Omni One SDK in your project, please send us an email at{' '}
									<a href="mailto:dev-support@virtuix.com">dev&#8209;support@virtuix.com</a> with the following information:
								</p>
								<p>
									<ul className={styles.SupportPageListPadding}>
										<li className={styles.SupportPageListItem}>Your Windows version</li>
										<li className={styles.SupportPageListItem}>Your Unity or Unreal version </li>
										<li className={styles.SupportPageListItem}>Your Omni One SDK Version </li>
										<li className={styles.SupportPageListItem}>A brief description of your issue and steps to reproduce it</li>
									</ul>
								</p>
								<p>If possible, please also send us a log of the issue you've encountered from your editor.</p>
								<p>Our support team will get back to you within 1-2 business days.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
